<h2>{{'companyClient.account.password' | translate}}</h2>
<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" method="post" class="space-top" #resetPwForm="ngForm">
  <div class="tab-content-form register">
    <password-field [form]="changePasswordForm" [controlName]="'oldPassword'" [labelKey]="'FormOldPassword'" [showHint]="false"></password-field>
    <password-field [form]="changePasswordForm" [controlName]="'newPassword'" [labelKey]="'FormNewPassword'" [errorMessageKey]="'LoginPasswordRequirementsHint'"></password-field>
    <password-field [form]="changePasswordForm" [controlName]="'passwordConfirm'" [labelKey]="'FormNewPasswordConfirm'" [errorMessageKey]="'PasswordsDoNotMatch'"></password-field>
  </div>
  <submit-button [isSendingRequest]="isSendingRequest" [disabled]="changePasswordForm.invalid" [id]="'submitPassword'"></submit-button>
</form>
